import { render } from "./PropertySelect.vue?vue&type=template&id=cbdbf568&scoped=true"
import script from "./PropertySelect.vue?vue&type=script&lang=js"
export * from "./PropertySelect.vue?vue&type=script&lang=js"

import "./PropertySelect.vue?vue&type=style&index=0&id=cbdbf568&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbdbf568"]])

export default __exports__